module.exports = __webpack_public_path__ + "media/images/games/clash-royale/hiw-1-bd6e79b71224565f89253bf0b83e761b.jpg";